import { Component } from "react"
import PropTypes from "prop-types"
import { keysIn, omit, replace, toLower } from "lodash"
import { validateWatchlistName } from "helpers/watchlists"
import { TextField, FormControl, DialogContent, DialogActions, Button } from "@mui/material"
import "./style.scss"

function computeDisabledButton({ name, errors }) {
  return !name || keysIn(errors).length > 0
}

class EditWatchlist extends Component {
  static propTypes = {
    name: PropTypes.string,
    id: PropTypes.string,
    description: PropTypes.string,
    saveWatchlist: PropTypes.func.isRequired,
    applyAction: PropTypes.func,
    alias: PropTypes.string,
    heapSubmitId: PropTypes.string,
    close: PropTypes.func,
  }

  constructor(props) {
    super(props)
    const errors = {}
    const state = {
      name: props.name || "",
      description: props.description || "",
      alias: props.alias || "",
    }

    if (state.name && !validateWatchlistName(state.name)) {
      errors.name = true
    }

    this.state = { ...state, errors, submitDisabled: true }
  }

  onChange = event => {
    const { id } = this.props
    const { value, name } = event.target
    const changes = {
      errors: { ...this.state.errors },
    }

    if (name === "description") {
      changes.description = value
    } else {
      changes.name = value

      if (!id) {
        changes.alias = replace(toLower(value), /[\s-]/g, "_")
      }

      if (!validateWatchlistName(value) && !changes.errors.name) {
        changes.errors.name = true
      } else if (validateWatchlistName(value) && changes.errors[name]) {
        changes.errors = omit(changes.errors, name)
      }
    }

    const newState = { ...this.state, ...changes }
    newState.submitDisabled = computeDisabledButton(newState)
    this.setState(newState)
  }

  submitWatchlist = () => {
    const { name, description } = this.state
    const { id } = this.props
    this.props.saveWatchlist(id, { name, description })
  }

  onKeyPress = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      const errors = this.validateWatchlist()
      if (keysIn(errors).length === 0) {
        this.saveWatchlist()
      }
    }
  }

  saveWatchlist = () => {
    const { applyAction } = this.props
    const errors = this.validateWatchlist()

    if (keysIn(errors).length > 0) {
      this.setState({ errors, submitDisabled: true })
    } else if (applyAction) {
      applyAction(this.submitWatchlist, null, null, true)()
    } else {
      this.submitWatchlist()
    }
  }

  validateWatchlist = () => {
    const { name } = this.state
    const errors = {}

    if (!validateWatchlistName(name)) {
      errors.name = true
    }

    return errors
  }

  render() {
    const { name, errors, submitDisabled, alias, description } = this.state
    const { close, id, heapSubmitId } = this.props

    return <div className="components_edit-watchlist">
      <DialogContent className="edit-watchlist-content-wrapper">
        <div>
          <FormControl variant="standard" className="watchlist-name-wrapper name-input-wrapper">
            <TextField
              variant="standard"
              id="watchlist-name"
              name="name"
              className="name-input"
              label="Watchlist Name"
              value={name}
              error={errors.name}
              onChange={this.onChange}
              onKeyDown={this.onKeyPress}
              margin="normal"
              helperText={errors.name ? "Invalid name. Please follow naming guidelines." : "3-50 chars long. Alphanum, _, -, and spaces."}
              slotProps={{
                formHelperText: { error: errors.name, classes: { root: "watchlist-name-error" } },
              }}
            />
          </FormControl>
          {id && <FormControl variant="standard">
            <TextField
              variant="standard"
              disabled
              name="alias"
              className="name-input"
              label="Alias"
              value={alias}
              margin="normal"
            />
          </FormControl>}
        </div>
        <FormControl
          variant="standard"
          className="watchlist-description-wrapper description-input-wrapper"
        >
          <TextField
            variant="standard"
            id="watchlist-description"
            name="description"
            multiline
            className="description-input"
            label="Watchlist Description"
            value={description}
            onChange={this.onChange}
            onKeyDown={this.onKeyPress}
            margin="normal"
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={close}>Cancel</Button>
        <Button color="primary" id={heapSubmitId} disabled={submitDisabled} onClick={this.saveWatchlist}>
          {id ? "Update watchlist" : "Create watchlist"}
        </Button>
      </DialogActions>
    </div>
  }
}

export default EditWatchlist
